import { Alert, Button, Center, Paper, PasswordInput, Stack, Text, TextInput, Title } from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';
import { type FormEvent, useState } from 'react';
import { signIn } from '../auth.ts';

/* The console's sign-in: email and password, checked by the API. One card on the canvas, the same
 * Mantine parts and tokens as the rest of the console. */
export function SignInPage({ apiUrl }: { apiUrl: string }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(null);
    const problem = await signIn(apiUrl, email, password);
    if (problem) {
      setError(problem);
      setBusy(false);
      return;
    }
    // The console starts signed in on the next load, on the page that was asked for.
    window.location.reload();
  }

  return (
    <Center mih="100vh" bg="gray.0" p="md">
      <Paper withBorder radius="md" p="xl" w="100%" maw={400}>
        <form onSubmit={(event) => void submit(event)}>
          <Stack gap="lg">
            <Stack gap={4}>
              <Text fw={700} size="sm" c="dimmed">
                Budovan admin
              </Text>
              <Title order={2}>Log in</Title>
              <Text size="sm" c="dimmed">
                Use the email and password your Budovan admin gave you.
              </Text>
            </Stack>
            {error ? (
              <Alert color="red" variant="light" icon={<IconAlertCircle size={18} />} role="alert">
                {error}
              </Alert>
            ) : null}
            <TextInput
              label="Email"
              type="email"
              autoComplete="username"
              placeholder="name@company.com"
              required
              autoFocus
              value={email}
              onChange={(event) => setEmail(event.currentTarget.value)}
            />
            <PasswordInput
              label="Password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(event) => setPassword(event.currentTarget.value)}
            />
            <Button type="submit" fullWidth loading={busy} disabled={!email.trim() || !password}>
              Log in
            </Button>
          </Stack>
        </form>
      </Paper>
    </Center>
  );
}
